export const GET_MAINTENANCE_TEMPLATES = `V3GET_MAINTENANCE_TEMPLATES`;
export const GET_MAINTENANCE_COMPONENTS = "V3_GET_MAINTENANCE_COMPONENTS";
export const GET_MAINTENANCE_SERVICES = "V3_GET_MAINTENANCE_SERVICES";
export const GET_MAINTENANCE_RULES = "V3_GET_MAINTENANCE_RULES";
export const CU_MAINTENANCE_COMPONENT = "V3_CU_MAINTENANCE_COMPONENT";
export const CU_MAINTENANCE_SERVICE = "V3_CU_MAINTENANCE_SERVICE";